import type { BetterDoc } from "@/types/__generated__/union-types"

export const isBetterDocRequired = (betterDocUsage: BetterDoc | null): boolean => betterDocUsage === "REQUIRED"
